import(/* webpackMode: "eager", webpackExports: ["LoginClient"] */ "/opt/buildhome/repo/platform/app/login/login-client.tsx");
